// @flow

import type { GrossRentCertification } from './types';

export const isGrcMissingPriorFullCertData = (
  cert: GrossRentCertification | null | void,
): boolean => {
  if (!cert || typeof cert !== 'object') {
    return false;
  }

  const { priorCertificationDate, hasPriorHUDCerts, prevMissingCert } = cert;

  if (priorCertificationDate == null) {
    return true;
  }

  if (hasPriorHUDCerts !== true && !prevMissingCert) {
    return true;
  }

  return false;
};

export const determineIf59aIsDisabled = (
  row: GrossRentCertification | null | void,
): boolean => {
  if (!row || typeof row !== 'object') {
    return false;
  }

  const { isCorrection, correction } = row;
  const disableForMissingCorrection = isCorrection && !correction;

  if (isGrcMissingPriorFullCertData(row)) {
    return true;
  }

  if (disableForMissingCorrection) {
    return true;
  }

  return false;
};

export const hasGrcGenerated59a = (
  cert: GrossRentCertification | null | void,
): boolean => {
  // Use generated59a (from generated59aDocumentId), not hasGenerated59 —
  // hasGenerated59 is copied from prior full certs and does not mean a 59A exists on this GR.
  return cert?.generated59a === true;
};
